import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { TextField } from '@src/components/TextField';
import { PasswordInput } from '@src/components/PasswordInput';
import { LOGIN_ROUTE } from '@src/Routes/links';
import { FormKey } from '../enums/formKey.enum';
import { StepOneProps } from './props';
import './styles.scss';

const FORM = [
  {
    key: FormKey.FULL_NAME,
    label: 'Your full name',
    placeholder: 'Your full name',
    type: 'text',
  },
  {
    key: FormKey.COMPANY_NAME,
    label: 'Company name',
    placeholder: 'Company name',
    type: 'text',
  },
  {
    key: FormKey.WORK_EMAIL,
    label: 'Work e-mail',
    placeholder: 'Work e-mail',
    type: 'text',
  },
  {
    key: FormKey.PASSWORD,
    label: 'Password',
    placeholder: 'Password',
    type: 'password',
  },
];

export const StepOne: FC<StepOneProps> = ({ formData, onChange }) => {
  return (
    <div className="register-step-one fade-in">
      <div className="register-step-one__header">
        <h4>Register as a company</h4>
        <p>
          Already have an account?
          <Link className="register-step-one__log-in" to={LOGIN_ROUTE}>
            Log in
          </Link>
        </p>
      </div>
      {FORM.map(({ key, label, placeholder, type }) => {
        if (key === FormKey.PASSWORD) {
          return (
            <PasswordInput
              errors={formData[key].error}
              key={key}
              onChange={value => onChange(key, value)}
              value={formData[key]?.value || ''}
            />
          );
        }

        return (
          <TextField
            defaultValue={formData[key]?.value || ''}
            fullWidth={true}
            key={key}
            label={label}
            message={formData[key]?.error || ''}
            messageType={!!formData[key]?.error && 'error'}
            onChange={value => onChange(key, value)}
            placeholder={placeholder}
            type={type}
            wrapperClassName="register-step-one__input"
          />
        );
      })}
    </div>
  );
};
